
import Vue from "vue"
import Icon from '@/components/icon/index.vue'
import Tooltip from '@/components/tooltip/index.vue'
import ImagLoader from '@/components/imgLoader/index.vue'
import { TIcon } from '@/components/icon'
import MenuItem from '@/components/Aside/menuItem/index.vue'
interface IRouterConfig {
	icon: TIcon,
	name: string,
	tooltip?: string
}

export default Vue.extend({
	data() {
		return {
			routes: [
				// {
				// 	icon: 'github',
				// 	name: 'github',
				// 	tooltip: require('@/assets/wechat.jpg')
				// },
				{
					icon: 'email',
					name: '1394705270asdf@gmail.com',
					// tooltip: require('@/assets/wechat.jpg')
				},
				{
					icon: 'wechat',
					name: '15590547823', tooltip: require('@/assets/wechat.jpg')
				},
				{
					icon: 'qq',
					name: '1394705270', tooltip: require('@/assets/qq.jpg')
				}

			] as Array<IRouterConfig>
		}
	},
	components: {
		Icon,
		Tooltip,
		ImagLoader,
		MenuItem
	}
})
